<template>
    <div class="container">
        <h2 class="title is-5">クラスのバインディング</h2>
        <p>クラスのバインディングのサンプルコード</p>
        <b-tag type="is-info">Vue.js</b-tag>
        <hr/>
        <h3 class="title is-5">サンプル</h3>
        <ClassBindingComponent />
        <hr/>
        <p class="title is-5">コード</p>
        <p style="margin-bottom:10px;"><b-button @click="twitterShare" class="is-info" size="is-small"><i class="fab fa-twitter"></i>シェアする</b-button></p>
        <div class="iframely-embed"><div class="iframely-responsive" style="padding-bottom: 56.2493%;"><a href="https://gist.github.com/katonobo/66183220e86a9dd6e3a26ad7dad6a979" data-iframely-url="//cdn.iframe.ly/vOpsCRy"></a></div></div>
        <hr>
        <p class="title is-5">解説</p>
        <p>・「active」をバインディングし、ボタンで真偽値を変更します。「true」の時に、cssで指定した文字が赤くなります。</p>
    </div>
</template>

<script>
import ClassBindingComponent from  '@/components/ClassBindingComponent.vue'
export default {
    components:{
        ClassBindingComponent
    },
    mounted(){
        const title = "クラスのバインディングのサンプルコード｜あめねこサンプルコード集"
        const description = "Vue.jsで書かれたクラスのバインディングを実装するサンプルコードです。"
        document.title = title
        document.querySelector("meta[property='og:title']").setAttribute('content', title)
        document.querySelector("meta[name='description']").setAttribute('content', description)
        document.querySelector("meta[property='og:description']").setAttribute('content', description)
    
        window.iframely.load();
    },
    methods:{
        twitterShare(){
            var shareURL = 'https://twitter.com/intent/tweet?text=' + "クラスのバインディングのサンプルコード" + "%20%23あめねこサンプルコード集" + '&url=' + "https://code.ameneko.com/class-binding";  
            location.href = shareURL
        }
    }
}
</script>

<style scoped>
.container{
    max-width: 1000px;
    margin:auto;
    margin-bottom: 40px;
    padding: 10px;
}

</style>